// extracted by mini-css-extract-plugin
module.exports = {"root":"SiteGroupDescription_root__2G3wd"};